import { FormattedMessage } from 'react-intl';
import Box from '@mui/material/Box';
import { ShiftsIcon } from '@atoms/icons';
import { EmptyListPlaceholder } from '@molecules/dataDisplay';
import { DataGrid } from '@molecules/dataDisplay';
import { useQualificationsSettingsColumns } from './columns';
import { QualificationListItem } from '@libs/models/qualifications';
import { useQualificationsListFilterStore } from '@libs/store/qualifications/listFiltersStore';
import { GridLogicOperator } from '@mui/x-data-grid';

type StaffingPartnersListPageProps = {
  loading: boolean;
  rows: QualificationListItem[];
  localizationSubset: string;
};
export function QualificationsTable({ loading, rows, localizationSubset }: StaffingPartnersListPageProps) {
  const { activeFilters } = useQualificationsListFilterStore();
  const search = activeFilters.find((f) => f.key === 'search')?.value;
  return (
    <Box sx={{ height: '100%', width: '100%' }}>
      <DataGrid
        rows={rows}
        loading={loading}
        rowHeight={64}
        columns={useQualificationsSettingsColumns({
          localizationSubset,
        })}
        filterModel={{
          items: [
            { field: 'name', operator: 'contains', value: search },
            // { field: 'abbreviation', operator: 'contains', value: search },
          ],
          // logicOperator: GridLogicOperator.Or,
        }}
        hideFooter
        disableRowSelectionOnClick
        noRowsOverlay={
          <EmptyListPlaceholder
            icon={<ShiftsIcon active />}
            title={<FormattedMessage id={`${localizationSubset}.table.noRows.title`} />}
            subtitle={<FormattedMessage id={`${localizationSubset}.table.noRows.subtitle`} />}
          />
        }
      />
    </Box>
  );
}
